import './index.css';

import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { VersionProvider } from 'lib/context/VersionProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import GeneralComponents from './lib/common/GeneralComponents';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './services/redux/store';
import theme from './theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const intervalInMS = process.env.REACT_APP_POLLING_INTERVAL
  ? parseInt(process.env.REACT_APP_POLLING_INTERVAL)
  : null;

const initialVersion = process.env.REACT_APP_VERSION ?? '';
const queryClient = new QueryClient();

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" />
          <link
            href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&family=Montserrat:wght@100;300;600&family=Nunito+Sans:opsz,wght@6..12,200;6..12,400;6..12,600&family=Nunito:wght@200;400;600&display=swap"
            rel="stylesheet"
          />
          <VersionProvider
            initialVersion={initialVersion}
            intervalInMS={intervalInMS}
          >
            <div>
              <App />
              <GeneralComponents />
            </div>
          </VersionProvider>
        </ThemeProvider>
      </PersistGate>
    </QueryClientProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
